import { CoreQuery } from '@/common/services/core-query';
import { EntitiesList } from '@/common/models';
import { authorizeClient, httpClientCoreQuery } from '@/api/http-client';
import { ICoursePlayerCourse, ICoursePlayerPage } from '@/courses/models';
import { DeviceType, PlayerCourseApiFactory } from '@eloomi/eloomi-learning-persona-client/1.0';
import { extractAxiosData } from '@/common/services/extractAxiosData';

const playerCourseApi = authorizeClient(PlayerCourseApiFactory);

export function getPageDetails(query: CoreQuery, { courseId, chapterId, pageId }): Promise<ICoursePlayerPage> {
    const q = query.path([
        EntitiesList.LEARNING,
        EntitiesList.PERSONA,
        EntitiesList.PLAYER,
        EntitiesList.COURSE,
        courseId,
        EntitiesList.CHAPTER,
        chapterId,
        EntitiesList.PAGE,
        pageId,
    ]);

    return httpClientCoreQuery.get(q).then(({ data }) => data);
}

export function getCourse(courseId: number) {
    return playerCourseApi.getCourseWithStructure(courseId).then(extractAxiosData) as Promise<ICoursePlayerCourse>;
}

export function completePage(query: CoreQuery, { courseId, chapterId, pageId }): Promise<any> {
    const q = query.path([
        EntitiesList.LEARNING,
        EntitiesList.PERSONA,
        EntitiesList.PLAYER,
        EntitiesList.COURSE,
        courseId,
        EntitiesList.CHAPTER,
        chapterId,
        EntitiesList.PAGE,
        pageId,
        EntitiesList.COMPLETE,
    ]);

    return httpClientCoreQuery.post(q).then(({ data }) => data);
}

export function incrementCourseViews(
    query: CoreQuery,
    { courseId, userId }: { courseId: number; userId: number }
): Promise<any> {
    const q = query.path([
        EntitiesList.LEARNING,
        EntitiesList.PERSONA,
        EntitiesList.PLAYER,
        EntitiesList.COURSE,
        courseId,
        EntitiesList.VIEWS,
        EntitiesList.USER,
        userId,
        EntitiesList.INCREMENT,
    ]);

    return httpClientCoreQuery.post(q).then(data => data);
}

export function trackActivity(payload: {
    courseId: number | string;
    chapterId: number | string;
    pageId: number | string;
    deviceType?: DeviceType | null;
}): Promise<any> {
    const query = new CoreQuery();

    const q = query.path([
        EntitiesList.LEARNING,
        EntitiesList.PERSONA,
        EntitiesList.PLAYER,
        EntitiesList.COURSE,
        payload.courseId,
        EntitiesList.CHAPTER,
        payload.chapterId,
        EntitiesList.PAGE,
        payload.pageId,
        EntitiesList.TRACK,
    ]);

    return httpClientCoreQuery
        .post(q, {
            device_type: payload.deviceType,
        })
        .then(data => data);
}
